module.exports = __webpack_public_path__ + "static/img/wing_558n.41f0430.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_558n.jpg
// module id = S5Iv
// module chunks = 0